import React from "react"
import NewsCard from "./news-card";
import images from "./images";
import BlogFeaturedRegulatoryUpdateCard from "./blog-featured-regulatory-update-card";
import LazyLoad from "react-lazyload"
import { Spinner } from "reactstrap"

const MixPostGrid = data =>  {

    let color = ['rgb(3, 67, 137)','rgb(222, 141, 10)','rgb(0, 145, 180)','rgb(3, 67, 137)','rgb(0, 145, 180)','rgb(20, 175, 188)','rgb(20, 175, 188)','rgb(222, 141, 10)'];

    let img = [images.artboard_2, images.artboard_8, images.artboard_1, images.artboard_6, images.artboard_5, images.artboard_3, images.artboard_7, images.artboard_4];


    let color2 = ['linear-gradient(45deg, rgba(255,255,255,1) 0%, rgba(214,219,255,1) 60%)', 'linear-gradient(336deg, rgba(255,255,255,1) 0%, rgba(243,255,209,1) 60%)','linear-gradient(336deg, rgba(255,255,255,1) 0%, rgba(214,255,227,1) 60%)', 'linear-gradient(336deg, rgba(255,255,255,1) 0%, rgba(0,145,180,1) 60%)'];

    let tempArr = [].concat(data.data.regulatoryArr).concat(data.data.insightArr).concat(data.data.newsArr);
    let tl = tempArr.length;

    let allArr = [];

    for (let i2 = 0; i2 < tl; i2++) {
        let indv = '';
        let ind = 0;
        for (let i = 0; i < tempArr.length; i++) {
            if (indv !== '') {
                if (new Date(tempArr[i].node.date) > new Date(indv)) {
                    indv = tempArr[i].node.date;
                    ind = i
                }
            } else {
                indv = tempArr[i].node.date
            }
        }
        allArr.push(tempArr[ind]);
        tempArr.splice(ind, 1)
    }


    let type3Arr = [];
    let maxlength = 2;


    return (
        <>


            <div className="row py-5">

                {
                    allArr.map((e, i) => {
                        if(e.node.type === "regulatory-update"){
                            return(

                                <LazyLoad className="col-12 p-2" key={i} placeholder={<Spinner></Spinner>}>
                                    <div className={"border-0"}>
                                        <BlogFeaturedRegulatoryUpdateCard data={e} img={img[i%img.length]} color={color[i%color.length]}/>
                                    </div>
                                </LazyLoad>
                            )

                        }
                        else {
                            if(type3Arr.length === maxlength){
                                type3Arr.push(e)
                                let itemList=[];
                                type3Arr.forEach((node, i2) => {
                                    itemList.push(
                                        <LazyLoad placeholder={<Spinner></Spinner>} className="col-12 col-lg-4  p-2" key={i2}>
                                            <div className={"card border-0 h-100 fsm-one-side-shadow rounded-0   card-hover-effect"} style={{background:color2[i2 % color2.length]}}>
                                                <NewsCard data={node} />
                                            </div>
                                        </LazyLoad>
                                    )
                                })

                                type3Arr.length = 0;
                                return (<>{itemList}</>);

                            }else {
                                type3Arr.push(e)
                            }
                        }

                    })
                }
                {
                    type3Arr.map((node2, i3) => {
                        return(
                            <>
                                <LazyLoad placeholder={<Spinner></Spinner>} className="col-12 col-lg-4  p-2" key={i3}>
                                    <div className={"card border-0 h-100 fsm-one-side-shadow rounded-0   card-hover-effect"} style={{background:color2[i3 % color2.length]}}>
                                        <NewsCard data={node2} />
                                    </div>
                                </LazyLoad>
                            </>
                        )
                    })
                }


            </div>

        </>
    )
}

export default MixPostGrid
